import Iconify from 'src/components/iconify';

export function getNavConfig(authenticated: boolean) {
  const nav = [
    {
      title: 'Trang chủ',
      icon: <Iconify icon="solar:home-2-bold-duotone" />,
      path: '/',
    },
    {
      title: 'Giới thiệu',
      icon: <Iconify icon="solar:home-2-bold-duotone" />,
      path: '/about-us',
    },
    {
      title: 'Liên hệ',
      icon: <Iconify icon="solar:home-2-bold-duotone" />,
      path: '/contact-us',
    },
  ];

  if (authenticated) {
    nav.splice(2, 0, {
      title: 'Cây sâm của tôi',
      icon: <Iconify icon="solar:home-2-bold-duotone" />,
      path: '/caysam/me',
    });
  }

  return nav;
}
